module.exports = __webpack_public_path__ + "static/img/icon_course.79c3f17e.png";